import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";

// The canonical set of possible event fields in your domain
const AVAILABLE_FIELDS = [
  { key: "date_executed", label: "Date Executed" },
  { key: "amount", label: "Amount" },
  { key: "output", label: "Output" },
  { key: "notes", label: "Notes" },
];

const EventTypeForm = ({ onSubmit, onCancel, initialData = null }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    input_fields: [],
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        description: initialData.description || "",
        input_fields: initialData.input_fields || [],
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFieldToggle = (fieldKey) => {
    setFormData((prev) => {
      const fields = prev.input_fields.includes(fieldKey)
        ? prev.input_fields.filter((f) => f !== fieldKey)
        : [...prev.input_fields, fieldKey];
      return { ...prev, input_fields: fields };
    });
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box>
      <TextField
        fullWidth
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        margin="normal"
        size="small"
      />
      <TextField
        fullWidth
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        margin="normal"
        multiline
        rows={3}
        size="small"
      />

      <Box mt={2}>
        <Typography variant="subtitle1" gutterBottom>
          Fields for this event
        </Typography>
        <FormGroup>
          {AVAILABLE_FIELDS.map((field) => (
            <FormControlLabel
              key={field.key}
              control={
                <Checkbox
                  checked={formData.input_fields.includes(field.key)}
                  onChange={() => handleFieldToggle(field.key)}
                />
              }
              label={field.label}
            />
          ))}
        </FormGroup>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
        <Button onClick={onCancel} className="vintage-button">Cancel</Button>
        <Button variant="outlined" onClick={handleSubmit} className="vintage-button">
          {initialData ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default EventTypeForm;
